// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:53:44

export default {
  "id": "traffic-tap-puzzle",
  "slug": "traffic-tap-puzzle",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/7837dbfeadba4ea784444131650fb8f6-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/7837dbfeadba4ea784444131650fb8f6/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Traffic Tap Puzzle",
      "description": "Traffic Tap Puzzle is a challenging puzzle game where players must control traffic at intersections by tapping on cars to start or stop them. The goal is to avoid collisions while ensuring a smooth flow of vehicles. As the levels progress, traffic becomes more complex, requiring strategic timing and quick decision-making. With engaging mechanics and increasing difficulty, the game tests your reflexes and planning skills.",
      "instructions": "Tap on a car to make it move or stop.\nTime your taps carefully to prevent crashes.\nLet all cars pass safely to complete the level.\nThe difficulty increases with more cars and faster movement.\nPlan ahead and react quickly to manage traffic efficiently.\n",
      "genres": [
        "Casual"
      ],
      "tags": [
        "car",
        "reflex",
        "traffic"
      ]
    },
    "zh-CN": {
      "title": "交通滴答拼图",
      "description": "交通点击谜题是一款挑战性的益智游戏，玩家需要通过点击车辆来控制路口的交通。目标是避免碰撞，同时确保车辆流畅通行。随着关卡难度提升，交通情况变得更加复杂，需要策略性的时机把握和快速决策。游戏通过引人入胜的机制和不断上升的难度，考验你的反应速度和规划能力。",
      "instructions": "点击汽车使其移动或停止。\n仔细计时点击以防止碰撞。\n让所有汽车安全通过以完成关卡。\n难度随着汽车数量增加和移动速度加快而提高。\n提前规划并快速反应以高效管理交通。",
      "genres": [
        "休闲"
      ],
      "tags": [
        "汽车",
        "反应",
        "交通"
      ]
    },
    "zh-TW": {
      "title": "交通點擊謎題",
      "description": "交通節奏拼圖是一款挑戰性的拼圖遊戲，玩家必須透過點擊車輛來控制交叉路口的交通，開始或停止車輛。目標是避免碰撞，同時確保車輛流暢通行。隨著關卡進行，交通變得更加複雜，需要策略性的時間安排和快速的決策。這款遊戲具有吸引人的機制和逐漸增加的難度，測試你的反應速度和計劃能力。",
      "instructions": "點擊車輛使其移動或停止。\n小心計時點擊，以防止碰撞。\n讓所有車輛安全通過以完成關卡。\n隨著車輛增多和移動速度加快，難度會提升。\n預先規劃並迅速反應，以有效管理交通。",
      "genres": [
        "休闲"
      ],
      "tags": [
        "車輛",
        "反應",
        "交通"
      ]
    },
    "zh-HK": {
      "title": "交通滴答謎",
      "description": "交通點擊謎題是一款挑戰性的謎題遊戲，玩家必須透過點擊車輛來控制十字路口的交通，啟動或停止車輛。目標是避免撞車，同時確保車輛流暢。隨著關卡進行，交通變得更加複雜，需要策略性的時間掌控和迅速的決策。這款遊戲透過引人入勝的機制和逐漸增加的難度，考驗玩家的反應速度和計劃技巧。",
      "instructions": "輕觸車輛以控制其移動或停止。\n小心計時您的觸碰，以避免碰撞。\n讓所有車輛安全通過以完成關卡。\n隨著車輛增多和移動速度加快，難度會提升。\n預先規劃並迅速反應，以有效管理交通。",
      "genres": [
        "隨意"
      ],
      "tags": [
        "車輛",
        "反應",
        "交通"
      ]
    },
    "ja": {
      "title": "トラフィックタップパズル",
      "description": "トラフィック・タップ・パズルは、交差点での交通を制御するために車両をタップして始動または停止させる挑戦的なパズルゲームです。目標は衝突を避けながら車両のスムーズな流れを確保することです。レベルが進むにつれて、交通がより複雑になり、戦略的なタイミングと迅速な判断が必要になります。魅力的なメカニクスと増加する難易度で、あなたの反応速度と計画能力を試します。",
      "instructions": "車をタップして動かしたり停止させます。\nタップのタイミングを慎重に合わせて衝突を避けます。\n全ての車が安全に通過することでレベルをクリアします。\n車の数が増え、動きが速くなるにつれて難易度が上がります。\n計画を立て、迅速な反応で交通を効率的に管理します。",
      "genres": [
        "カジュアル"
      ],
      "tags": [
        "車",
        "反応速度",
        "交通"
      ]
    },
    "ko": {
      "title": "교통 탭 퍼즐",
      "description": "traffic tap puzzle는 교차로의 교통을 조종하여 차량을 시작하거나 멈추게 하며 교통사고를 피하고 차량의 원활한 흐름을 보장해야 하는 도전적인 패ズル 게임입니다. 목표는 차량의 원활한 흐름을 유지하면서 충돌을 피하는 것입니다. 레벨이 진행됨에 따라 교통이 더 복잡해지며, 전략적인 시간 조정과 빠른 결정을 요구합니다. 매력적인 메커니즘과 증가하는 난이도로 게임은 반응 속도와 계획 능력을 테스트합니다.",
      "instructions": "차에 탭하여 이동하거나 멈추게 하세요.\n타이밍을 신중하게 하여 충돌을 방지하세요.\n모든 차량이 안전하게 지나가도록 하여 레벨을 완료하세요.\n차량이 많고 빠르게 움직일수록 난이도가 증가합니다.\n효율적으로 교통을 관리하기 위해 미리 계획하고 빠르게 반응하세요.",
      "genres": [
        "캐주얼"
      ],
      "tags": [
        "カー",
        "反応속도",
        "交通"
      ]
    },
    "fr": {
      "title": "Puzzle de Trafic Tap",
      "description": "Traffic Tap Puzzle est un jeu de puzzle défiant où les joueurs doivent contrôler le trafic aux intersections en tapant sur les voitures pour les démarrer ou les arrêter. Le but est d'éviter les collisions tout en assurant un flux fluide des véhicules. À mesure que les niveaux avancent, le trafic devient plus complexe, nécessitant une temporalisation stratégique et des décisions rapides. Avec des mécanismes engageants et une difficulté croissante, le jeu teste vos réflexes et vos compétences en planification.",
      "instructions": "Tapez sur une voiture pour la faire bouger ou arrêter.\nGarez vos tapes avec précision pour éviter les accidents.\nLaissez toutes les voitures passer en toute sécurité pour terminer le niveau.\nLa difficulté augmente avec plus de voitures et un déplacement plus rapide.\nPlanifiez à l'avance et réagissez rapidement pour gérer le trafic efficacement.",
      "genres": [
        "Occasionnel"
      ],
      "tags": [
        "car : voiture\nreflex : réflexe\ntraffic : trafic"
      ]
    }
  }
};
